<div class="personal-plan-upsell-dialog">
  <div mat-dialog-title class="personal-plan-upsell-dialog__title">
    <h2 data-testid="personal-plan-upsell-title">{{ content.title }}</h2>
    <button
      mat-icon-button
      type="button"
      class="personal-plan-upsell-dialog__close"
      aria-label="Close"
      data-testid="personal-plan-upsell-close-button"
      (click)="dismiss()"
    >
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <section class="personal-plan-upsell-dialog__plan-summary">
      <p class="personal-plan-upsell-dialog__message">Your Free Plan includes 1 wheel and 5 saved sessions</p>
    </section>

    <section class="personal-plan-upsell-dialog__plan-summary personal-plan-upsell-dialog__plan-summary--personal">
      <p class="personal-plan-upsell-dialog__message">Upgrade to the Personal Plan to keep tracking your progress with:</p>
      <ul class="plan-card__features" data-testid="personal-plan-upsell-personal-features">
        @for (feature of content.personalPlanFeatures; track feature) {
        <li class="plan-card__feature">{{ feature }}</li>
        }
      </ul>
    </section>

    @if (content.reassurance) {
    <p class="personal-plan-upsell-dialog__reassurance" data-testid="personal-plan-upsell-reassurance">{{ content.reassurance }}</p>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <wil-cta-button
      [disabled]="false"
      [loading]="false"
      [style]="'secondary'"
      [size]="'small'"
      [ctaText]="content.secondaryAction"
      data-testid="personal-plan-upsell-secondary-button"
      (ctaClick)="dismiss()"
    ></wil-cta-button>
    <wil-cta-button
      [disabled]="false"
      [loading]="false"
      [style]="'primary'"
      [size]="'small'"
      [ctaText]="content.primaryAction"
      data-testid="personal-plan-upsell-primary-button"
      (ctaClick)="upgrade()"
    ></wil-cta-button>
  </mat-dialog-actions>
</div>
